import { createAsyncThunk } from '@reduxjs/toolkit';
import { _priceUrls } from '@custom/Utils/constants/apiUrls';

const getModifiedCreditHospitals = createAsyncThunk('getModifiedCreditHospitals', async (id:any) => {
  try {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    let url = _priceUrls.getModifiedCreditHospitals;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ _id: id }),
    });
    if (!response.ok) {
      throw new Error('Failed to fetch price data');
    }
    return await response.json();
  } catch (error) {
    return Promise.reject(error);
  }
});

export default getModifiedCreditHospitals;
